/* eslint-disable unicorn/no-array-for-each */
/* eslint-disable unicorn/prefer-array-some */
/* eslint-disable unicorn/consistent-function-scoping */
/* eslint-disable class-methods-use-this,no-param-reassign,no-underscore-dangle,no-console */

import * as d3 from 'd3';
import { nanoid } from 'nanoid';
import APIV5 from '~/models/api';

const width = 800;
const height = 600;

const LEGEND_OFFSET = 30;

/** @type {NodeGraphViewer.Definition} */
export default class {
	/** @type {Knitiv.RepreService} */
	RepreService;

	/** @type {Knitiv.Angular.Timeout} */
	$timeout;

	/** @type {Knitiv.Angular.Element} */
	$element;

	/** @type {d3.Simulation<d3.SimulationNodeDatum, undefined> | null} */
	simulation;

	/* @ngInject */
	/**
	 * @param {Knitiv.Angular.Timeout} $timeout
	 * @param {Knitiv.Angular.Element} $element
	 * @param {Knitiv.RepreService} RepreService
	 */
	constructor(
		$timeout,
		$element,
		RepreService,
	) {
		this.simulation = null;
		this.svg = null;
		this.$timeout = $timeout;
		this.$element = $element;
		this.RepreService = RepreService;

		// component
		this.roots = [];
		this.directions = [];
		this.selected = {};

		/** @type {NodeGraphViewer.JSONData} */
		this.data = {
			nodes: [],
			links: [],
		};
		this.types = new Map();
		this.nodeContainer = null;

		this.diagonal = d3.linkHorizontal().x(d => d.x).y(d => d.y);
	}

	/**
	 * @param {d3.Simulation<d3.SimulationNodeDatum, undefined>} simulation
	 */
	drag(simulation) {
		/**
		 * @param {{ active: any; }} event
		 * @param {NodeGraphViewer.JSONDataNode} d
		 */
		function dragstarted(event, d) {
			if (!event.active) {
				simulation.alphaTarget(0.3).restart();
			}
			d.fx = d.x;
			d.fy = d.y;
		}

		/**
		 * @param {{ x: any; y: any; }} event
		 * @param {NodeGraphViewer.JSONDataNode} d
		 */
		const dragged = (event, d) => {
			d.fx = event.x;
			d.fy = event.y;
		};

		/**
		 * @param {{ active: any; }} event
		 * @param {NodeGraphViewer.JSONDataNode} d
		 */
		function dragended(event, d) {
			if (!event.active) {
				simulation.alphaTarget(0);
			}
			d.fx = null;
			d.fy = null;
		}

		return d3.drag()
			.on('start', dragstarted)
			.on('drag', dragged)
			.on('end', dragended);
	}

	/**
	 * @param {{ kid: any; name: any; type_kid: any; isa: any; initiator: any; }} node
	 * @param fetched
	 */
	insertNode(node, fetched = false) {
		const {
			kid,
			name,
			type_kid: typeKid,
			isa,
			initiator,
		} = node;
		// Cannot use links as they are not added yet
		// const haveLinks = this.nodeHaveLinks(kid);
		if (
			// not already exist
			!this.data.nodes.find(dataNode => dataNode.id === kid)
			/* &&
			(
				// have links
				haveLinks ||
				// or have no links but is root
				this.isRootId(kid)
			) */
		) {
			console.log('node', node);
			this.data.nodes.push({
				id: kid,
				label: name.length > 20 ? `${name.slice(0, 20)}...` : name,
				title: name,
				shown: true,
				fetched,
				radius: 8,
				type: typeKid,
				isLoading: false,
				isa,
				collapsed: false,
				collapsing: false,
				initiator,
			});
		}
	}

	/**
	 * Insert data into the graph
	 *
	 * @param {{ blocs: any; nodes: any; }} data - The data to add
	 * @param {string} initiator - Who caused the data to be added
	 */
	insertData(data, initiator) {
		const {
			blocs, nodes,
		} = data;

		/**
		 * @param {NodeGraphViewer.JSONDataNode} node
		 */
		for (const node of nodes) {
			node.initiator = node.kid === initiator ? null : initiator;
			this.insertNode(node, this.isRootId(node.kid));
		}

		/**
		 * @param {{ links: any; }} bloc
		 */
		/**
		 * @param {{ links: any; }} bloc
		 */
		for (const bloc of blocs) {
			// for each blocs

			const { links } = bloc;

			/**
			 * @param {{ [x: string]: any; objnum: any; objnum2: any; relation_kid: any; }} link
			 */
			/**
			 * @param {{ [x: string]: any; objnum: any; objnum2: any; relation_kid: any; }} link
			 */
			for (const link of links) {
				const id = nanoid();

				const {
					objnum,
					objnum2,
					relation_kid: relationKid,
					...rest
				} = link;

				this.data.nodes.find(node => node.id === objnum).collapsed = false;
				this.data.nodes.find(node => node.id === objnum).collapsing = false;

				this.data.nodes.find(node => node.id === objnum2).collapsed = false;
				this.data.nodes.find(node => node.id === objnum2).collapsing = false;

				this.data.links.push({
					id,
					source: objnum,
					target: objnum2,
					relationType: relationKid,
					shown: true,
					collapsed: false,
					initiator,
					...rest,
				});
			}
		}
	}

	/**
	 * @param {{ isa: string; objname: any; isaname: any; }} link
	 */
	resolveName(link) {
		return link.isa === 'K_NODE;SYS_CLASSE' ? link.objname : `${link.isaname} : ${link.objname}`;
	}

	/**
	 * @param {d3.SimulationNodeDatum[]} nodes
	 * @param {NodeGraphViewer.JSONDataLink[]} links
	 */
	updateSimulation(nodes, links) {
		if (this.simulation !== null && this.simulation !== undefined) {
			this.simulation.nodes(nodes);
			this.simulation.force('link').links(links);

			this.simulation.alpha(0.7).restart();
		}
	}

	/**
	 * @param {string} id
	 */
	isRootId(id) {
		return this.roots.includes(id);
	}

	/**
	 * @param {any} nodeId
	 */
	nodeHaveLinks(nodeId) {
		return this.nodeCountLinks(nodeId) > 0;
	}

	nodeCountLinks(nodeId) {
		const linksLinkedToNode = this.data.links.filter(
			link => link.target.id === nodeId || link.source.id === nodeId,
		);

		return linksLinkedToNode.length;
	}

	/**
	 * @param {NodeGraphViewer.JSONDataNode} node
	 * @param collapsed
	 */
	toggleCollapseStateChildren(node, collapsed = true) {
		// Collapse all nodes that have only one link and that is linked to (node)
		this.data.nodes.forEach((dataNode, index, nodes) => {
			if (dataNode.initiator === node.id && this.nodeCountLinks(dataNode.id) === 1) {
				this.toggleCollapseStateChildren(nodes[index], collapsed);
				nodes[index].collapsed = collapsed;
			}
		});
	}

	toggleCollapseLink() {
		this.data.links.forEach((child, index, dataLinks) => {
			const sourceHidden = child.source.collapsed;
			const targetHidden = child.target.collapsed;

			dataLinks[index].collapsed = sourceHidden || targetHidden;
		});
	}

	update() {
		const showRelations = new Set(this.getTypesAsArray().filter(type => type.shown).map(type => type.kid));
		const keepLinks = this.data.links.filter(link => showRelations.has(link.relationType));

		// console.log('links', links);
		this.updateSimulation(this.data.nodes, this.data.links);

		// Set link visibility based on filters
		for (const link of this.data.links) {
			link.shown = !!keepLinks.map(keepLink => keepLink.relationType).includes(link.relationType);
		}

		// Set node visibility based on link visibility & links amount
		for (const node of this.data.nodes) {
			const linksLinkedToNode = this.data.links.filter(
				link => link.shown && (link.target.id === node.id || link.source.id === node.id),
			);

			node.shown = linksLinkedToNode.length > 0 || this.isRootId(node.id);
		}

		const links = this.data.links.filter(d => !d.collapsed && d.shown);
		const nodes = this.data.nodes.filter(d => !d.collapsed && d.shown);

		this.legendContainer.select('rect').attr('height', () => {
			const amount = this.getTypesAsArray().map(type => type.shown);
			return 16 + (amount.length * 20) + 4;
		});

		this.legendContainer
			.selectAll('g')
			.data(this.getTypesAsArray())
			.join(
				enter => {
					const root = enter
						.append('g')
						.attr('class', 'legend-line')
						.style('cursor', 'pointer')
						.on('click', (event, d) => this.toggleTypeVisibility(d));

					root
						.append('circle')
						.attr('cx', LEGEND_OFFSET)
						.attr('cy', (d, index) => LEGEND_OFFSET + index * 20)
						.attr('r', 8)
						.style('fill', d => d.kjson.style.color);

					root
						.append('text')
						.attr('x', LEGEND_OFFSET + 20)
						.attr('y', (d, index) => LEGEND_OFFSET + index * 20)
						.style('fill', d => d.kjson.style.color)
						.text(d => d.nom)
						.attr('text-anchor', 'left')
						.attr('font-size', '10')
						.style('alignment-baseline', 'middle');

					return root;
				},
			)
			.attr('opacity', d => (d.shown ? 1 : 0.15));

		this.linksContainer
			.attr('fill', 'none')
			.selectAll('g')
			.data(links, d => d.id)
			.join(
				enter => {
					const root = enter.append('g').attr('class', 'link-group');

					const id = nanoid();

					const { types } = this;

					root.append('line')
						.attr('id', id)
						.on('click', (event, d) => console.log(d))
						.each((d, index, linesNodes) => {
							const defaultArrow = {
								arrow: 'none',
								color: '#000',
								'stroke-dasharray': '0',
								'stroke-width': 1.5,
							};
							const style = { ...defaultArrow, ...types.get(d.relationType)?.kjson.style };

							const element = d3.select(linesNodes[index]);

							element.attr('stroke', style.color);
							element.attr('stroke-dasharray', style['stroke-dasharray']);
							element.attr('stroke-width', style['stroke-width']);

							const arrowDirection = {
								from() {
									return element.attr('marker-start', `url(#arrow-${d.relationType})`);
								},
								to() {
									return element.attr('marker-end', `url(#arrow-${d.relationType})`);
								},
								both() {
									return element
										.attr('marker-start', `url(#arrow-${d.relationType})`)
										.attr('marker-end', `url(#arrow-${d.relationType})`);
								},
								none() {},
							};

							return arrowDirection[style.arrow]();
						});
				},
				update => {
					const circle = update.selectAll('circle');

					circle.attr('stroke', 'yellow');

					return circle;
				},
				exit => exit.remove(),
			);

		this.edgepaths = this.root.selectAll('.edgepath')
			.data(links)
			.enter()
			.append('path')
			.attr('class', 'edgepath')
			.attr('fill-opacity', 0)
			.attr('stroke-opacity', 0)
			.attr('id', (d, index) => `edgepath${ index}`)
			.style('pointer-events', 'none');

		this.edgelabels = this.root.selectAll('.edgelabel')
			.data(links)
			.enter()
			.append('text')
			.style('pointer-events', 'none')
			.attr('class', 'edgelabel')
			.attr('font-size', 10)
			.attr('fill', '#aaa')
			.attr('dy', '-10')
			.attr('id', (d, index) => `edgelabel${ index}`);

		this.edgelabels.append('textPath')
			.attr('xlink:href', (d, index) => `#edgepath${ index}`)
			.style('text-anchor', 'middle')
			.style('pointer-events', 'none')
			.attr('startOffset', '50%')
			.text(d => {
				const linker = d.linker_kid;
				return linker === '0' ? '' : linker;
			});
		// .style('display', d => (d.shown ? '' : 'none'));

		this.nodeContainer
			.attr('stroke-linecap', 'round')
			.attr('stroke-linejoin', 'round')
			.selectAll('g')
			.data(nodes, d => d.id)
			.join(
				enter => {
					const root = enter.append('g');

					root
						.on('mouseover', d => {
							if (!d.shown) {
								return;
							}
							const directNodes = new Set(
								this.data.links.filter(x => x.source.id === d.id || x.target.id === d.id)
									.map(x => (x.source.id === d.id ? x.target.id : x.source.id)),
							);

							this.svg
								.selectAll('.nodes .node')
								.transition()
								.attr('opacity', c => (directNodes.has(c.id) || c.id === d.id ? 1 : 0.05));

							this.svg
								.selectAll('.nodes .node .isa')
								.transition()
								.attr('opacity', c => (c.id === d.id ? 1 : 0));

							this.svg
								.selectAll('.links .link-group')
								.transition()
								.attr('opacity', c => (c.source.id === d.id || c.target.id === d.id ? 1 : 0.05));
						})
						.on('mouseout', d => {
							if (!d.shown) {
								return;
							}
							this.svg
								.selectAll('.nodes .node')
								.transition()
								.attr('opacity', '1');

							this.svg
								.selectAll('.links .link-group')
								.transition()
								.attr('opacity', '1');

							// Show only isa of selected element
							this.svg
								.selectAll('.nodes .node .isa')
								.transition()
								.attr('opacity', '0');
						})
						.on('click', event => {
							event.preventDefault();
							event.stopPropagation();
						})
						.on(
							'dblclick',
							/**
							 * Execute on double click
							 *
							 * @param event
							 * @param {NodeGraphViewer.JSONDataNode} d
							 */
							async (event, d) => {
								event.preventDefault();
								event.stopPropagation();

								if (d.fetched) {
									d.collapsing = !d.collapsing;
									this.toggleCollapseStateChildren(d, d.collapsing);
									this.toggleCollapseLink();

									// hide links
									// this.data.links.forEach((child, i, dataLinks) => {
									// 	if (child.initiator === d.id) {
									// 		console.log('child', child);
									// 		const sourceHidden = child.source.collapsed || child.source.collapsing;
									// 		const targetHidden = child.target.collapsed || child.target.collapsing;

									// 		dataLinks[i].collapsed = sourceHidden || targetHidden;
									// 	}
									// });
								}
								else {
									d.isLoading = true;
									this.update();
									const newData = await this.fetchObject(d.id);
									this.insertData(newData, d.id);
									d.isLoading = false;
									d.fetched = true;
								}
								this.update();
							},
						);

					root
						.append('circle')
						.attr('r', d => d.radius)
						.attr('fill', d => this.color(d.type));

					root
						.append('text')
						.attr('class', 'label')
						.attr('alignment-baseline', 'middle')
						.attr('text-anchor', 'middle')
						.attr('dy', -20)
						.text(d => d.label ?? d.id)
						.attr('fill', 'black')
						.attr('title', d => d.title)
						.attr('stroke', 'black');

					root
						.append('text')
						.attr('class', 'isa')
						.attr('alignment-baseline', 'middle')
						.attr('text-anchor', 'middle')
						.attr('dy', 25)
						.text(d => this.data.nodes.find(node => node.id === d.isa)?.label ?? '')
						.attr('fill', 'black')
						.attr('stroke', 'black')
						.attr('opacity', '0.35');

					return root;
				},
				update => update,
				exit => exit.remove(),
			)
			.attr('class', 'node')
			// .style('display', d => (d.shown ? '' : 'none'))
			.call(this.drag(this.simulation));

		this.updateSimulation(nodes, links);
	}

	ticked() {
		this.svg.selectAll('.legend-line').attr('opacity', d => (d.shown ? 1 : 0.25));

		// Compute line orientation
		this.svg.selectAll('.link-group')
			.selectAll('line')
			.attr('x1', d => d.source.x)
			.attr('y1', d => d.source.y)
			.attr('x2', d => d.target.x)
			.attr('y2', d => d.target.y);

		if (this.edgepaths) {
			this.edgepaths.attr('d', d => `M ${ d.source.x } ${ d.source.y } L ${ d.target.x } ${ d.target.y}`);
		}

		if (this.edgelabels) {
			console.log('this.edgelabels', this.edgelabels);
			this.edgelabels.attr('transform', function (d) {
				if (d.target.x < d.source.x) {
					const bbox = this.getBBox();

					const rx = bbox.x + bbox.width / 2;
					const ry = bbox.y + bbox.height / 2;
					return `rotate(180 ${ rx } ${ ry })`;
				}

				return 'rotate(0)';
			});
		}

		this.svg
			.selectAll('.node')
			.attr('transform', d => `translate(${d.x},${d.y})`)
			.attr('stroke', d => (d.fetched ? 'red' : 'black'));

		this.legendContainer.raise();
	}

	/**
	 * @param {string} kid
	 */
	fetchObject(kid) {
		const blocs = [];
		if (this.directions === 'all' || this.directions?.includes('down')) {
			blocs.push({
				type: 'down',
				conditions: [
					/* {
						relation_kid: COMPOSED_OF,
					}, */
				],
			});
		}

		if (this.directions === 'all' || this.directions?.includes('up')) {
			blocs.push({
				type: 'up',
				conditions: [],
			});
		}

		if (this.directions === 'all' || this.directions?.includes('def')) {
			blocs.push({
				type: 'def',
				conditions: [],
			});
		}

		if (this.directions === 'all' || this.directions?.includes('object')) {
			blocs.push({
				type: 'object',
				conditions: [],
			});
		}
		return APIV5.instance.objectAround({
			blocs,
			root_kid: kid,
		}, { id: 'node-graph-view.fetch-object' });
	}

	getTypesAsArray() {
		let links = this.data.links.map(link => link.relationType);
		links = [...new Set(links)];

		return [...this.types.entries()]
			.map(([key, value]) => ({
				id: key,
				...value,
			}))
			.filter(type => {
				if (links.length > 0) {
					return links.includes(type.id);
				}
				return type;
			});
	}

	/**
	 * @param {{ kid: any; shown: any; }} d
	 */
	toggleTypeVisibility(d) {
		this.types.get(d.kid).shown = !d.shown;
		this.update();
	}

	async init() {
		/* Get links */
		const links = await APIV5.instance.objectList(
			{ classKid: 'K_NODE;RELATION' },
			{ id: 'node-graph-view.init' },
		);

		for (const [kid, link] of Object.entries(links.list)) {
			link.kjson = link.kjson ?? {};
			link.shown = true;
			link.kid = kid;
			const repreData = [];
			if (link.repre_all) {
				Object.entries(link.repre_all).forEach(([langKid, langData]) => {
					repreData.push({
						lang: {
							kid: langKid,
							isa: langData.lang_isa,
						},
						name: langData.name,
					});
				});
				link.nom = this.RepreService.getRepre(repreData).name;
			}

			console.log('link', link);

			this.types.set(link.kid, link);
		}
		/* --- */

		const roots = await Promise.all(this.roots.map(rootId => this.fetchObject(rootId)));

		// Setup svg
		this.svg = d3
			.select(this.$element[0])
			.select('.graph')
			.append('svg')
			.attr('viewBox', `0 0 ${width} ${height}`)
			.style('font', '12px sans-serif')
			.call(
				d3
					.zoom()
					.scaleExtent([-50, 3])
					.on('zoom', event => {
						this.root.attr('transform', event.transform);
					}),
			)
			.on('dblclick.zoom', null);

		// Setup legend
		this.legendContainer = this.svg
			.append('g')
			.attr('class', 'legend');

		// Setup root element
		this.root = this.svg
			.append('g')
			.attr('class', 'root');

		// Setup defs
		this.defs = this.root.append('defs');

		// Setup links
		this.linksContainer = this.root.append('g').attr('class', 'links');

		// Setup nodes
		this.nodeContainer = this.root.append('g').attr('class', 'nodes');

		this.edgelabels = null;
		this.edgepaths = null;

		/* Setup arrow markers */
		const marker = this.defs
			.selectAll('marker')
			.data(this.getTypesAsArray())
			.join('marker');

		marker
			.attr('id', d => `arrow-${d.id}`)
			.attr('viewBox', '0 -5 10 10')
			.attr('refX', 16)
			.attr('refY', 0)
			.attr('markerWidth', 8)
			.attr('markerHeight', 8)
			.attr('orient', 'auto')
			.append('path')
			.attr('fill', d => d.kjson.style.color)
			.attr('d', 'M0,-5L10,0L0,5');
		// .attr('d', d => this.diagonal(d));
		/* --- */

		this.color = d3.scaleOrdinal(d3.schemeCategory10);

		// Setup legend rect
		this.legendContainer
			.append('rect')
			.attr('width', 150)
			.attr('fill', 'white')
			.attr('stroke', 'grey')
			.attr('opacity', '0.75')
			.attr('x', 10)
			.attr('y', 10);

		this.forceLinks = d3.forceLink().id(d => d.id).distance(150);
		// Setup simulation
		this.simulation = d3.forceSimulation()
			.force('link', this.forceLinks)
			.force('charge', d3.forceManyBody().strength(-180))
			.force('center', d3.forceCenter(width / 2, height / 2))
			.force('collision', d3.forceCollide(12))
			.on('tick', () => this.ticked());

		for (const [index, root] of roots.entries()) {
			this.insertData(root, this.roots[index]);
		}

		this.update();

		return this.svg.node();
	}

	/**
	 * @param {{ roots: any; directions: Directions; }} changes
	 */
	async $onChanges(changes) {
		if (changes.roots && changes.directions) {
			await this.init();
		}
	}
}
